module.exports = __webpack_public_path__ + "static/media/LOADERpage_BG.fafc97d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADERpage_BG.png
// module id = 321
// module chunks = 0